module.exports = __webpack_public_path__ + "img/logo-flextronix.aa647e9.png";